var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.574 25.982c-.25 2.679-.335 3.85 1.256 4.018.67 0 1.841 0 2.009-1.34.166-1.338-.839-5.021-.504-8.62.335-3.6 1.172-4.855 1.925-5.776.755-.92 1.76-.586 2.596-.586.837 0 3.348-.837 5.357-3.013 2.01-2.177 2.01-6.697 2.177-7.617.167-.921-.503-1.256-2.177-.921-1.674.335-4.352 1.674-6.194 4.52-1.474 2.277-3.907 9.096-4.94 12.22-.418-1.227-2.142-4.151-5.69-6.026-4.437-2.343-6.446-1.087-6.948-.752-.503.334-.67.585 0 1.088.67.502 3.097 3.934 5.357 4.603 1.807.535 3.263-1.173 3.765-2.093.39.223 1.34.987 2.01 2.26.836 1.59.25 5.357 0 8.035z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRad);
export default __webpack_public_path__ + "static/media/RAD.9eadd5d4d35a1b60e20a60604f1b3869.svg";
export { ForwardRef as ReactComponent };